import { movies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function HotMoviesSection() {
  const hotMovies = movies.filter((m) => m.isHot).slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">热门推荐</h2>
            <p className="text-xs md:text-sm text-foreground-400 mt-1">大家都在看的热门好片</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {hotMovies.map((movie) => (
            <MovieCard key={movie.id} {...movie} size="large" />
          ))}
        </div>

        <div className="mt-8 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-500/10 flex-shrink-0">
            <i className="ri-film-line text-xl text-accent-400"></i>
          </div>
          <div className="flex-1">
            <h3 className="text-base font-semibold text-foreground-100 mb-1">更多精彩分类</h3>
            <p className="text-sm text-foreground-400">动作片、喜剧片、科幻片、爱情片、恐怖片... 快看影视为您提供超过 500+ 部高清电影资源。</p>
          </div>
          <a
            href="/category/dongzuo"
            className="px-5 py-2.5 rounded-lg bg-accent-500 text-accent-50 text-sm font-semibold hover:bg-accent-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即浏览
          </a>
        </div>
      </div>
    </section>
  );
}